import groq from 'groq';

import { AMAZON_BUTTON } from './amazonButton';
import { PRODUCT_MEDIA } from './productMedia';
import { PRODUCT_WITH_VARIANTS } from './productWithVariants';
import { PROMO_CODE_BLOCK_OR_PARENT } from './promoCode';

export const PRODUCT_OVERRIDES = `
  productOverrides {
    title,
    subtitle,
    description,
    "media": media[] { ${PRODUCT_MEDIA} }
  }
`;

export const PRODUCT_IN_BLOCK = groq`
  _type,
  productWithVariants {
    ${PRODUCT_WITH_VARIANTS}
  },
  ${PRODUCT_OVERRIDES},
  "purchaseType": select(purchaseType == "all" => undefined, purchaseType),
  "promoCodes": ${PROMO_CODE_BLOCK_OR_PARENT},
  "isPromoCodeVisible": coalesce(isPromoCodeVisible, true),
  "isDiscountHidden": coalesce(isDiscountHidden, false),
  ctaType,
  ${AMAZON_BUTTON}
`;
